<div class="blank-state text-center row justify-content-center align-items-center">
    <div class="col-md-6">
        <div class="mb-3 pmd-avatar pmd-avatar-secondary pmd-avatar-md d-inline-flex"
            aria-hidden="true">
            <span class="material-icons material-symbols-outlined pmd-icon-sm"
                aria-hidden="true">
                search
            </span>
        </div>
        <p class="fs-6 fw-semibold mb-1 text-black"
            tabindex="0">
            No results found!
        </p>
        <p class="mb-4"
            tabindex="0">
            We couldn't find any results matching your search. Try a different keyword or filter.
        </p>
    </div>
</div>